import type { ButtonProps } from '@chakra-ui/react';
import { IconButton as ChakraIconButton } from '@chakra-ui/react';
import * as React from 'react';
import { Close } from 'core/img';
import { SvgIcon } from './SvgIcon';

export type CloseButtonProps = {
	iconWidth?: string
	iconHeight?: string
} & ButtonProps

export const CloseButton = React.forwardRef<
	HTMLButtonElement,
	CloseButtonProps
>(function CloseButton(props, ref) {
	return (
		<ChakraIconButton variant="ghost" aria-label="Close" ref={ref} tabIndex={-1} {...props}>
			{props.children ?? <SvgIcon src={Close} h={props.iconHeight ?? '7'} w={props.iconWidth ?? '7'} />}
		</ChakraIconButton>
	);
});
